import { Theme, css } from '@emotion/react';

import { useEffect, useState } from 'react';

import { Spacing, Typography } from 'chatie-design-system';

import CharacterPlaCardList from '@components/characters/CharacterPlaCardList';
import SwipeableListContainer from '@components/common/SwipableListContainer';
import { CharacterTag } from '@components/modal/CharacterTagSelectionModal';

import { getCharacterList } from '@api/character';
import { QUERY_KEYS } from '@constants';
import { useChatPaginationQuery } from '@utils/query';

// const containerCSS = (rowCount: number) => css`
//   display: grid;
//   grid-auto-flow: column;
//   grid-template-rows: repeat(${rowCount}, 1fr);
//   .skeleton {
//     height: ${62}px;

//     width: 300px;
//     padding: ${Spacing.small}px;
//     margin: ${Spacing.small}px;
//     border-radius: ${Radius.small}px;
//   }
// `;

const titleCSS = css`
  padding: 0 ${Spacing.medium}px;
  margin-bottom: ${Spacing.xsmall}px;
`;

const tagContainerCSS = (theme: Theme) => css`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  padding: 0 ${Spacing.xsmall}px;

  p {
    ${Typography.body12}
    color:${theme.var.gray500};
  }
`;

const tagCSS = (selected: boolean) => (theme: Theme) =>
  css`
    display: flex;
    align-items: center;
    margin-left: ${Spacing.xsmall}px;
    svg {
      height: 24px;
    }

    button {
      background-color: ${selected ? `${theme.var.black};` : `null`};
    }

    .icon-text {
      span {
        color: ${selected ? `${theme.var.white};` : `${theme.var.black}`};
      }
      height: 31px;
    }
  `;

type SwipableTagListProps = {
  title: string;

  rowCount: number;
  contentCount: number;

  onClickCard?: (id: number) => void;
  onClickProfile?: (id: number) => void;
  tags: {
    id: number;
    name: string;
    payload: {
      createdAt: string;
      dynamic_object: {
        tagged_character_count: number;
        related_tag_ids: number[];
      };
    };
  }[];
};

type PlaCardFetcherProps = {
  selectedIds: number[];
  rowCount: number;
  contentCount: number;

  onClickCard?: (id: number) => void;
  onClickProfile?: (id: number) => void;
};

const CharacterPlaCardFetcher = (props: PlaCardFetcherProps) => {
  const { selectedIds } = props;
  const query = useChatPaginationQuery(
    QUERY_KEYS.CHARACTER.TAG(selectedIds, 'stat__message_count'),
    () =>
      getCharacterList(
        { tag_ids: selectedIds, order_by: 'stat__message_count' },
        1,
        props.contentCount
      ),
    {
      enabled: !!selectedIds?.length,
    }
  );

  return (
    <>
      {query.data?.pages[0].items && (
        <CharacterPlaCardList
          {...props}
          characters={query.data?.pages[0].items}
        />
      )}
    </>
  );
};

const SwipableTagList = ({
  tags,
  title,
  onClickProfile,
  onClickCard,
  rowCount = 4,
  contentCount = 16,
}: SwipableTagListProps) => {
  const [selected, setSelected] = useState<number[]>([]);

  useEffect(() => {
    if (tags?.length) {
      setSelected([
        tags[0]?.id,
        ...tags[0]?.payload.dynamic_object?.related_tag_ids,
      ]);
    }
  }, [tags]);

  return (
    <div>
      <h5 css={titleCSS}>{`${title}`}</h5>
      <div css={tagContainerCSS}>
        <SwipeableListContainer className="tagList">
          {tags.map((item, index) => (
            <div css={tagCSS(selected[0] === item.id)} key={`tag_${index}`}>
              <CharacterTag
                name={item.name}
                onClick={() =>
                  setSelected([
                    item.id,
                    ...item.payload?.dynamic_object?.related_tag_ids,
                  ])
                }
              />
            </div>
          ))}
        </SwipeableListContainer>
      </div>
      {/* <Suspense
        fallback={
          <div css={containerCSS(rowCount)}>
            {Array(rowCount * 2)
              .fill(undefined)
              .map((_, idx) => (
                <Frame className="skeleton" key={idx} />
              ))}
          </div>
        }
      > */}
      <CharacterPlaCardFetcher
        selectedIds={selected}
        onClickCard={onClickCard}
        onClickProfile={onClickProfile}
        rowCount={rowCount}
        contentCount={contentCount}
      />
      {/* </Suspense> */}
    </div>
  );
};

export default SwipableTagList;
